import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function DC4List({ user }) {
  const [dc4List, setDc4List] = useState([]);
  const [loading, setLoading] = useState(true);

  const isAdmin = user && user.role === 'Admin';

  useEffect(() => {
    fetchDC4();
  }, []);

  const fetchDC4 = async () => {
    try {
      const response = await axios.get('/api/dc4');
      setDc4List(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Erreur:', error);
      setLoading(false);
    }
  };

  const handleGenerate = async (id, type) => {
    try {
      let url;
      if (type === 'dc4pdf') url = `/api/dc4/${id}/generate-pdf`;
      else if (type === 'contrat') url = `/api/dc4/${id}/generate-contrat`;
      else url = `/api/dc4/${id}/generate?format=docx`;

      const response = await axios.post(url);
      const baseUrl = window.location.origin.includes('localhost') ? 'http://localhost:3001' : window.location.origin; window.open(baseUrl + response.data.downloadUrl, '_blank');
    } catch (error) {
      alert(error.response?.data?.details || 'Erreur lors de la génération du document');
    }
  };

  const handleSendContrat = async (id) => {
    if (!window.confirm('Envoyer le contrat par email au sous-traitant ?')) return;
    try {
      const response = await axios.post(`/api/dc4/${id}/send-contrat`);
      alert(response.data.message);
    } catch (error) {
      alert(error.response?.data?.error || 'Erreur lors de l\'envoi');
    }
  };

  if (loading) return <div className="loading">Chargement...</div>;

  return (
    <div className="card">
      <div className="card-header">
        <h1 className="card-title">DC4 - Déclarations de sous-traitance</h1>
        <Link to="/dc4/new" className="btn btn-success">+ Nouveau DC4</Link>
      </div>

      <table>
        <thead>
          <tr>
            <th>Numéro</th>
            {isAdmin && <th>Entreprise</th>}
            <th>Sous-traitant</th>
            <th>Marché</th>
            <th>Client</th>
            <th>Montant</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {dc4List.length === 0 ? (
            <tr>
              <td colSpan={isAdmin ? 8 : 7} style={{ textAlign: 'center', padding: '2rem' }}>
                Aucun DC4 trouvé
              </td>
            </tr>
          ) : (
            dc4List.map(dc4 => (
              <tr key={dc4.id}>
                <td><strong>{dc4.numero_dc4}</strong></td>
                {isAdmin && <td>{dc4.entreprise_nom || <em style={{ color: '#aaa' }}>—</em>}</td>}
                <td>{dc4.soustraitant_nom}</td>
                <td>{dc4.intitule_marche}</td>
                <td>{dc4.client_nom}</td>
                <td>{dc4.montant_previsionnel ? dc4.montant_previsionnel + ' €' : 'N/A'}</td>
                <td>
                  <span className={'badge badge-' + (
                    dc4.statut === 'Validé' ? 'success' : 
                    dc4.statut === 'En cours' ? 'info' : 'warning'
                  )}>
                    {dc4.statut}
                  </span>
                </td>
                <td>
                  <div className="actions" style={{ display: 'flex', gap: '0.3rem', flexWrap: 'wrap' }}>
                    <Link to={'/dc4/' + dc4.id} className="btn btn-primary" title="Modifier"
                      style={{ padding: '0.35rem 0.6rem', minWidth: '32px', textAlign: 'center' }}>M</Link>
                    {dc4.statut === 'Validé' && (
                      <>
                        <button onClick={() => handleGenerate(dc4.id, 'docx')} className="btn btn-success"
                          title="Générer DC4 DOCX (template officiel)" style={{ padding: '0.35rem 0.6rem', fontSize: '0.78rem' }}>
                          DC4
                        </button>
                        <button onClick={() => handleGenerate(dc4.id, 'contrat')} className="btn btn-success"
                          title="Générer Contrat PDF" style={{ padding: '0.35rem 0.6rem', fontSize: '0.78rem' }}>
                          Contrat
                        </button>
                        <button onClick={() => handleSendContrat(dc4.id)}
                          style={{ padding: '0.35rem 0.6rem', fontSize: '0.78rem', background: '#8e44ad', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                          title="Envoyer le contrat par email au sous-traitant">
                          ✉ Envoyer
                        </button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default DC4List;
